import React from "react";
import "./GuaranteeSection.css";
import guaranteeSeal from "assets/novaIcon.png";

export default function GuaranteeSection() {
  return (
    <section className="guarantee-section">
      <div className="guarantee-content">
        <div className="guarantee-seal">
          <img src={guaranteeSeal} alt="100% Money Back Guarantee" />
        </div>
        <div className="guarantee-text">
          <h3>Backed by our 100% Money Back Guarantee</h3>
          <p>
            If you don't get 1,000,000 views after you put this course into action, email us and we'll send you a full refund (eligible after 3 months).
          </p>
        </div>
      </div>
    </section>
  );
} 